import { Base } from "../base";
import { Scheduler } from "../scheduler";

export class UpdateParking extends Base {
    ParkingID?: number;
    ParkingTypeID?: number;
    ParkingLevelID?: number;
    Title?: string;
    Phone?: string;
    Email?: string;
    Latitude?: number;
    Longitude?: number;
    Address?: string;
    Location?: string;
    ContactName?: string;
    Scheduler?: Array<Scheduler>

    constructor(
        parkingId?: number,
        parkingTypeId?: number,
        parkingLevelId?: number,
        title?: string,
        phone?: string,
        email?: string,
        latitude?: number,
        longitude?: number,
        address?: string,
        location?: string,
        contactName?: string,
        scheduler?: Array<Scheduler>
    ) {
        super();
        this.ParkingID = parkingId;
        this.ParkingTypeID = parkingTypeId;
        this.ParkingLevelID = parkingLevelId;
        this.Title = title;
        this.Phone = phone;
        this.Email = email;
        this.Latitude = latitude;
        this.Longitude = longitude;
        this.Address = address;
        this.Location = location;
        this.ContactName = contactName;
        this.Scheduler = scheduler;
    }
}